import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0C1C2C", // Your main brand color
    },
    secondary: {
      main: "#F4C550", // Optional: your accent button color
    },
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif", // or your custom font
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
